<template>
  <hr>
                    <div class="row">
                        <div class="col-md-12 p-2 text-center" >
                        <p style="font-size: 0.8rem; line-height: 1rem !important; margin: 0px; padding: 0px; padding-bottom: 8px;">Bu site, <span style="color:#0769cc">Adalar Müzesi</span>'nin <strong>"Adalar'ın Kültür Mirası"</strong><br>projesi kapsamında hazırlanmıştır.</p>
                        <p><img src="/assets/img/vaha.png" alt=""></p>
                        <p style="font-size: 0.8rem; line-height: 1rem !important; margin: 0px; padding: 0px; display: none;">
                          2024 yılı hazırlıklarına destekleri nedeniyle Vaha-Adadayız(*) projesine teşekkür ederiz.</p>
                        <p style="font-size: 0.6rem; font-style: italic; line-height: 1rem !important; margin: 0px; padding: 0px; display: none">*(VAHA, Anadolu Kültür ve zusa girişimi olup, Stiftung Mercator ve European Cultural Foundation tarafından finanse edilmektedir. VAHA konsorsiyumu iac Berlin ile işbirliği içindedir.)pm run dev</p>
                        </div>
                      
                    </div>
                    
                    <div class="row mt-3">
                        <hr>
                          <div class="col-md-12 p-2 text-center" >
                          <p style="font-size: 0.6rem; line-height: 0.8rem !important; margin: 0px; padding: 0px;"> ©Adalar Vakfı - 2022-2025. Her hakkı saklıdır!<br><a href="https://extrarenk.com" target="_blank" style="text-decoration: none; color: black;">Extra Renk</a> tarafından <strong>"Adalar Vakfı"</strong> için hazırlanmıştır. </p>
                      
                          </div>
                       </div>
</template>


